export enum EventCategory {
    Asset = 'Asset',
    Grid = 'Grid',
    Site = 'Site',
}
